import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from './../../common/dialog';

class BhrMarkups extends Component {
    static propTypes = {
        bhrMarkups: PropTypes.array,
        activeElement: PropTypes.object,
        hideBhrMarkups: PropTypes.func,
        handleUpdateBhrMarkups: PropTypes.func,
        isSavingBhrMarkups: PropTypes.bool,
        handleSaveBhrMarkups: PropTypes.func,
        handleAddBhrMarkups: PropTypes.func,
        handleDeleteBhrMarkups: PropTypes.func
    };

    renderData() {
        const { bhrMarkups, handleUpdateBhrMarkups, activeElement } = this.props;
        return bhrMarkups.map((markup, index) => {
            let runningStyle = null;
            if (index === 0) {
                runningStyle = 'SW';
            } else if (index === 1) {
                runningStyle = 'WT';
            } else if (index === 2) {
                return null;
            } else if (index === 3) {
                if (activeElement['is_perfecting']) {
                    runningStyle = 'Perfecting';
                } else {
                    return null;
                }
            }

            return (
                <tr key={index}>
                    <td>{runningStyle}</td>
                    <td>
                        <input type="text" value={markup.markup}
                            onChange={handleUpdateBhrMarkups.bind(this, index, 'markup')} />
                    </td>
                </tr>
            );
        });
    }

    render() {
        const { hideBhrMarkups, handleSaveBhrMarkups, isSavingBhrMarkups } = this.props;

        let data = (
            <div>
                <table className="table table-sm table-striped data-table">
                    <thead>
                        <tr>
                            <th style={{ width: '50%' }}>Running Style</th>
                            <th style={{ width: '50%' }}>Markup</th>
                        </tr>
                    </thead>
                    <tbody>{this.renderData()}</tbody>
                </table>
            </div>
        );

        let saveButtonLabel = 'Save';
        if (isSavingBhrMarkups) {
            saveButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
        }

        let actions = [
            <button key="save-button" className="btn btn-light btn-sm action-button"
                onClick={handleSaveBhrMarkups} disabled={isSavingBhrMarkups}>{saveButtonLabel}</button>,
            <button key="close-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideBhrMarkups}>Close</button>
        ];
        return (
            <Dialog
                name="bhr-markups"
                modal={false}
                actions={actions}
                contentStyle={{ width: 800 }}
                bodyStyle={{ overflow: 'initial' }}
            >
                <div className="form-container">{data}</div>
            </Dialog>
        );
    }
}

export default BhrMarkups;
